import { useQuery } from '@tanstack/react-query';
import { getApplicationFormDetails, getApplications, getResourceFiles } from '@/api/Rover/ApplicationForm';
import { RoverReactQueryKey } from '@/constants/ReactQueryKeys';
import type { QueryParamsInterface } from '@/types/Shared';

interface IApplicationFormHookProps {
  formId: string;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useApplicationForm = ({ formId, onSuccess, onError }: IApplicationFormHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [RoverReactQueryKey.GET_APPLICATION_FORM_DETAILS],
    queryFn: () => getApplicationFormDetails({ applicationFormId: formId }),
    onSuccess,
    onError,
    enabled: !!formId,
  });
};

interface IApplicationsHookProps {
  formId: string;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useApplications = ({ formId, params, onSuccess, onError }: IApplicationsHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [RoverReactQueryKey.GET_APPLICATIONS, { formId, ...params }],
    queryFn: () => getApplications({ params: { formId, ...params } }),
    onSuccess,
    onError,
  });
};

interface IResourceHookProps {
  formId: string;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useResource = ({ formId, params, onSuccess, onError }: IResourceHookProps) => {
  //Tanstack: version 4 query implementation
  return useQuery({
    queryKey: [RoverReactQueryKey.GET_RESOURCE, { formId, ...params }],
    queryFn: () => getResourceFiles({ applicationFormId: formId, params }),
    onSuccess,
    onError,
  });
};
